var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferringIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0 C3.15,0 0,3.15 0,7 C0,10.85 3.15,14 7,14 C10.85,14 14,10.85 14,7 C14,3.15 10.85,0 7,0 Z M9.485,9.66 L6.629,7.903 C6.419,7.777 6.293,7.553 6.293,7.308 L6.293,4.025 C6.3,3.738 6.538,3.5 6.825,3.5 C7.112,3.5 7.35,3.738 7.35,4.025 L7.35,7.14 L10.038,8.757 C10.29,8.911 10.374,9.24 10.22,9.492 C10.066,9.737 9.737,9.814 9.485,9.66 Z",
    id: "Shape",
    fill: "#fecb48",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferringIconColor);
export default __webpack_public_path__ + "static/media/transferring_icon_color.52e9b25355ba087433cb13837fe1e06f.svg";
export { ForwardRef as ReactComponent };